import { IPaymentServiceState } from "./model"

export const paymentState: IPaymentServiceState = {
  stripe: null,
  nextTempEntityId: -1
}
